import { InfoGroupBookingAction } from "./actions";

export interface IInfoGroupBooking {
  isFetching: boolean;
  isFetchFailed: boolean;
  content: Julius.Website.GroupPageViewModel;
};

const initialInfoGroupBooking: IInfoGroupBooking = {
  isFetching: false,
  isFetchFailed: false,
  content: null,
};

function infoGroupBooking(
  state: IInfoGroupBooking = initialInfoGroupBooking, 
  action: InfoGroupBookingAction,
  ): IInfoGroupBooking {
    
  switch (action.type) {
    case 'SET_IS_FETCHING_GROUP_CONTENT':
      return {
        ...state,
        isFetching: true,
        isFetchFailed: false,
      };

    case 'SET_FETCH_GROUP_CONTENT_FAILED':
      return {
        ...state,
        isFetching: false,
        isFetchFailed: true,
      };

    case 'SET_GROUP_CONTENT':
      return {
        ...state,
        content: action.content,
        isFetching: false,
        isFetchFailed: false,
      };

    default:
      return state;
  }
}

export default infoGroupBooking;


// WEBPACK FOOTER //
// ./src/pages/InfoGroupBookingPage/Redux/reducer.tsx